import { Pipe, PipeTransform } from '@angular/core';
import {PhoneNumber} from "../interface/phone-number";

@Pipe({
  name: 'mainContractPhone'
})
export class MainContractPhonePipe implements PipeTransform {

  transform(value: any): any {
    return value.filter((el: PhoneNumber) => el.main);

  }

}
